import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell
} from '../../ui/table';
import { Badge } from '../../ui/badge';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount);
};

const RecentSales = ({ data }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Customer</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Amount</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((sale) => (
          <TableRow key={sale._id}>
            <TableCell>
              <div className="font-medium">{sale.user.firstName} {sale.user.lastName}</div>
              <div className="text-sm text-muted-foreground">{sale.user.email}</div>
            </TableCell>
            <TableCell>
              <Badge variant={
                sale.orderStatus === 'Delivered' ? 'success' :
                sale.orderStatus === 'Processing' ? 'warning' : 'default'
              }>
                {sale.orderStatus}
              </Badge>
            </TableCell>
            <TableCell className="text-right">{formatCurrency(sale.totalPrice)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default RecentSales;